import React from 'react';

import styles from './LomavisTableCell1.module.css';

export type LomavisTableCellAlign1 = 'start' | 'center' | 'end';
export type LomavisTableCellVariant1 = 'head' | 'body' | 'muted' | 'strong';

export interface LomavisTableCell1Props
  extends React.HTMLAttributes<HTMLTableCellElement> {
  as?: 'td' | 'th';
  align?: LomavisTableCellAlign1;
  children: React.ReactNode;
  className?: string;
  colSpan?: number;
  numeric?: boolean;
  nowrap?: boolean;
  rowSpan?: number;
  scope?: 'col' | 'row' | 'colgroup' | 'rowgroup';
  style?: React.CSSProperties;
  variant?: LomavisTableCellVariant1;
}

export const LomavisTableCell1: React.FC<LomavisTableCell1Props> = ({
  as = 'td',
  align = 'start',
  children,
  className = '',
  colSpan,
  numeric = false,
  nowrap = false,
  rowSpan,
  scope,
  style,
  variant = as === 'th' ? 'head' : 'body',
  ...rest
}) => {
  const Component = as;
  const alignClass =
    align === 'center'
      ? 'text-center'
      : align === 'end'
      ? 'text-end'
      : 'text-start';
  const variantClass =
    variant === 'head'
      ? 'text-muted fw-bold text-uppercase small'
      : variant === 'muted'
      ? 'text-muted fw-semibold'
      : variant === 'strong'
      ? 'text-body fw-bold'
      : 'text-body-secondary fw-semibold';

  return (
    <Component
      className={`align-middle ${variantClass} ${alignClass} ${
        numeric ? styles.numeric : ''
      } ${nowrap ? 'text-nowrap' : ''} ${className}`}
      colSpan={colSpan}
      rowSpan={rowSpan}
      scope={as === 'th' ? scope : undefined}
      style={style}
      {...rest}
    >
      {children}
    </Component>
  );
};
